module.exports = __webpack_public_path__ + "img/bussinessimg.42c6c031.png";